import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Dialog, Slide, Snackbar, IconButton } from "@mui/material";
import ThemedDialogContent from "./ThemedDialogContent";
import ThemedDialogTitle from "./ThemedDialogTitle";
import { decoratedFetch } from "../../req_utils";
import {
  DARK_THEME_BODY_COLOR,
  DARK_THEME_TEXT_COLOR,
  LIGHT_THEME_TEXT_COLOR,
  GENESIS_LOGO_COLOR,
} from "../../constants";
import CloseIcon from "@mui/icons-material/Close";
import MobileProjectDetailsTabs from "../MobileProjectDetailsTabs";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MobileEditProjectDialog({
  parentState,
  handleClose,
  onProjectUpdate,
}) {
  const darkThemeEnabled = useSelector((state) => state.darkThemeEnabled);
  const employee_branch_id = useSelector((state) => state.employee_branch_id);
  const [project, setProject] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const lookUpProject = (projectId) => {
    decoratedFetch(`/look_up_project/${projectId}`)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Unknown error");
        }
        return response.json();
      })
      .then((data) => {
        setProject(data);
      })
      .catch((error) => console.error("Error looking up project: ", error));
  };

  const listEmployees = () => {
    if (!employee_branch_id) return;
    
    decoratedFetch(`/list_employees?branch_id=${employee_branch_id}`)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Unknown error");
        }
        return response.json();
      })
      .then((data) => setEmployees(data.filter((employee) => employee.enabled)))
      .catch((error) => {
        console.error(`Error listing employees: ${error}`);
      });
  };

  useEffect(() => {
    if (parentState !== null && parentState?.selectedProject !== null) {
      lookUpProject(parentState?.selectedProject?.id);
    } else {
      setProject(null);
    }
    if (parentState !== null) listEmployees();
  }, [parentState, employee_branch_id]);

  const handleProjectUpdate = (updatedProject) => {
    // Update local project state to reflect changes in the dialog title
    setProject(updatedProject);
    // Also call the parent's onProjectUpdate callback
    if (onProjectUpdate) {
      onProjectUpdate(updatedProject);
    }
  };

  return (
    <>
      <Snackbar
        sx={{
          ".MuiSnackbarContent-root": {
            backgroundColor: GENESIS_LOGO_COLOR,
            minWidth: 0,
          },
        }}
        open={snackbarMessage}
        autoHideDuration={6000}
        onClose={() => setSnackbarMessage(null)}
        message={snackbarMessage}
      />
      <Dialog
        fullScreen
        open={parentState !== null}
        onClose={handleClose}
        TransitionComponent={Transition}
        aria-labelledby="edit-project-dialog-title"
      >
        <ThemedDialogTitle
          id="edit-project-dialog-title"
          sx={{
            backgroundColor: darkThemeEnabled
              ? DARK_THEME_BODY_COLOR
              : "#f7f7f7",
            p: "8px 16px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                color: darkThemeEnabled
                  ? DARK_THEME_TEXT_COLOR
                  : LIGHT_THEME_TEXT_COLOR,
                fontSize: "1rem",
                fontWeight: "bold",
                marginRight: "18px",
              }}
            >
              {parentState?.showCreateProjectView
                ? "Create Project"
                : project?.name
                  ? `${project?.name} (${project?.custom_id})`
                  : ""}
            </div>
            <div>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
                style={{
                  color: darkThemeEnabled
                    ? DARK_THEME_TEXT_COLOR
                    : LIGHT_THEME_TEXT_COLOR,
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </ThemedDialogTitle>
        <ThemedDialogContent
          sx={{
            backgroundColor: darkThemeEnabled
              ? DARK_THEME_BODY_COLOR
              : "#f7f7f7",
            p: 0,
          }}
        >
          {parentState && (
            <MobileProjectDetailsTabs
              project={project}
              employees={employees}
              setSnackbarMessage={setSnackbarMessage}
              onProjectUpdate={handleProjectUpdate}
            />
          )}
        </ThemedDialogContent>
      </Dialog>
    </>
  );
}
